import { LazyLoadImage } from "react-lazy-load-image-component";
import { useParams } from "react-router-dom";

function ColorSelecterSection({
  selectedSize,
  selectedColor,
  selectionColor
}) {
  const { sku } = useParams();
  if (!selectedSize?.product_colors?.length) {
    return "";
  }
  return (
    <div className="color-selector">

      <p>
        Select Colour : <span style={{ fontWeight: 600 }}>{selectedColor?.color}</span>
      </p>

      <div className="color-options">

        {selectedSize.product_colors.map((color) => {
          const isActive = sku === color.sku;
          return (
            <div
              key={color.sku}
              className={`selected-color${isActive ? " active-size" : ""}`}
              onClick={() => selectionColor(color)}
              style={{ padding: "3px" }}
            >
              <LazyLoadImage
                src={color.color_media}
                alt={color.color}
                width={60}
                height={60}
                style={{ 'cursor': "pointer" }}
                title={color.color}
              />
            </div>
          );
        })}

      </div>

    </div>
  );
}

export default ColorSelecterSection;